import request from '@/utils/request'

// 账号密码登录
export const login = data => {
  return request.post('/webapi/login', data)
}

// 验证码登录
export const smslogin = data => {
  return request.post('/webapi/smslogin', data)
}

// 获取当前用户手机号
export const getPhone = () => {
  return request.get('/webapi/getPhone')
}

// 登录态下更改密码
export const updatePass = (data) => {
  return request.post('/webapi/updatePass', data)
}

// 忘记密码修改密码
export const smsupdatePass = (data) => {
  return request.post('/webapi/smsupdatePass', data)
}

// 忘记密码-校验验证码
export const versmscode = (params) => {
  return request.get('/webapi/versmsCode', { params })
}

// 获取当前版本
export const getCurVersion = () => {
  return request.get('/webapi/version/getCurVersion')
}

// 获取用户信息
export const getSweepCodeUserInfo = data => {
  return request.post('/wxapi/wx/getSweepCodeUserInfo', data)
}

// 获取用户是否第一次登录
export const firstSweepLogin = data => {
  return request.post('/wxapi/wx/firstSweepLogin', data)
}

// 获取用户openid
export const sweepCodeLogin = data => {
  return request.post('/wxapi/wx/sweepCodeLogin', data)
}

// 注册
export const registerAccount = data => {
  return request.post('/webapi/registerAccount', data)
}

// 切换
export const switchCompany = data => {
  return request.post('/webapi/switch', data)
}
